import { isNil } from 'lodash';
import { ImageStyle, StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { SharedStyles } from '@shared/styles';
import { MBImage } from './MBImage';
import { MBImageURISource } from './props';
import { Styles } from './styles';

export interface MBIconProps {
  style?: StyleProp<ImageStyle | ViewStyle>;
  source?: MBImageURISource;
  size?: 'small' | 'normal' | 'large';
  color?: string;
  noPadding?: boolean;
  testID?: string;
}

export interface MBBoxedIconProps extends MBIconProps {
  /*
        Color of the rounded box around the icon
    */
  backgroundColor?: string;
}

/*
    Wrapper around image to make it easy to use icons. Icons have
    default sizes and can be colored.
*/
export function MBIcon({ style, source, color, noPadding, size = 'normal' }: MBIconProps) {
  return (
    <MBView
      style={[
        size === 'small' && Styles.iconSmall,
        size === 'normal' && Styles.iconNormal,
        size === 'large' && Styles.iconLarge,
        noPadding && Styles.noPadding,
        style,
      ]}
    >
      <MBImage style={SharedStyles.full} resizeMode="contain" source={source} tintColor={color} />
    </MBView>
  );
}

/*
    An icon wrapped in a rounded box with a background color.
    Default icon color is white.
*/
export function MBBoxedIcon({
  style,
  backgroundColor,
  size = 'normal',
  color = 'white',
  ...otherProps
}: MBBoxedIconProps) {
  return (
    <MBIcon
      {...otherProps}
      color={color}
      size={size}
      style={[
        size === 'small' && Styles.boxedIconSmall,
        size === 'normal' && Styles.boxedIconNormal,
        size === 'large' && Styles.boxedIconLarge,
        !isNil(backgroundColor) && { backgroundColor },
        style,
      ]}
    />
  );
}
